// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NLOrderFareInfo from "./NLOrderFareInfo.bs.js";
import * as NLOrderTripInfo from "./NLOrderTripInfo.bs.js";
import * as NLOrderContactInfo from "./NLOrderContactInfo.bs.js";
import * as NLOrderPaymentInfo from "./NLOrderPaymentInfo.bs.js";
import * as NLOrderPartnerDetails from "./NLOrderPartnerDetails.bs.js";
import * as NLOrderPricingStrategy from "./NLOrderPricingStrategy.bs.js";
import * as NLOrderMiscellaneousInfo from "./NLOrderMiscellaneousInfo.bs.js";

function NLOrderLeftSection(Props) {
  var order_crn = Props.order_crn;
  var order = Props.order;
  var order_fare = Props.order_fare;
  var load_assist_info = Props.load_assist_info;
  return React.createElement("div", {
              className: "nlo-left-section"
            }, React.createElement(NLOrderContactInfo.make, {
                  order: order
                }), React.createElement(NLOrderTripInfo.make, {
                  order: order,
                  order_fare: order_fare,
                  load_assist_info: load_assist_info
                }), React.createElement(NLOrderFareInfo.make, {
                  order_fare: order_fare
                }), React.createElement(NLOrderPaymentInfo.make, {
                  order_fare: order_fare
                }), React.createElement(NLOrderPricingStrategy.make, {
                  order: order
                }), React.createElement(NLOrderPartnerDetails.make, {
                  order_crn: order_crn
                }), React.createElement(NLOrderMiscellaneousInfo.make, {
                  order: order
                }));
}

var make = NLOrderLeftSection;

export {
  make ,
  
}
/* react Not a pure module */
